import React from 'react';
import { motion } from 'framer-motion';
export function EbookMockup({
  className = ''
}: {
  className?: string;
}) {
  return <motion.div className={`relative mx-auto ${className}`} initial={{
    y: 20,
    opacity: 0
  }} whileInView={{
    y: 0,
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-68">
      {/* Shadow */}
      <div className="absolute top-6 left-6 w-full h-full bg-black/25 blur-2xl rounded-2xl" data-id="element-69"></div>

      {/* Book Image */}
      <img src="https://cdn.magicpatterns.com/uploads/pHUPWnHzGpXhHs5SRZtLgy/carrusel_imagen_3.png" alt="SCORE 700 – Aquí es donde todo cambia" className="relative z-10 w-full max-w-4xl md:max-w-5xl h-auto drop-shadow-2xl" data-id="element-70" />
    </motion.div>;
}